.addDependencyIssueSelector {
	flex: 1 0 auto;
}
